// The stored session is shared by every tab (localStorage), but each tab
// also holds the user in memory and runs its own silent renew. When Sign
// Out in one tab removes the stored session, the browser fires a `storage`
// event in the others; they drop their in-memory session and stop renewing,
// so no other tab can quietly write the session back.
import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

const STORED_USER_PREFIX = 'oidc.user:';

/** @param {StorageEvent} event */
export const isStoredUserRemoval = (event) =>
  event.key === null || // localStorage.clear() in another tab
  (event.key.startsWith(STORED_USER_PREFIX) && event.oldValue !== null && event.newValue === null);

export const useCrossTabSignOut = () => {
  const auth = useAuth();

  useEffect(() => {
    const onStorage = (event) => {
      if (!auth.isAuthenticated || !isStoredUserRemoval(event)) return;
      auth.stopSilentRenew?.();
      auth.removeUser().catch(() => {});
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [auth]);
};
